// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"Filters__modalContainer___Ok44p","modalBody":"Filters__modalBody___2ABDg","title":"Filters__title___1MNU1","subtitle":"Filters__subtitle___3xK2t","dividerDouble":"Filters__dividerDouble___3DVHz","CTAContainer":"Filters__CTAContainer___1-MPk","filtersContainer":"Filters__filtersContainer___2qFKn"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/project/potentialMatches/components/Filters.scss
// module id = 1625
// module chunks = 0